export const processStatuses = [
  'ok',
  'pending',
  'error',
  'not-requested',
  'requesting',
] as const

/**
 * - not-requested: no action requested
 * - requesting: fv is still processing
 * - pending: fv processed this, but are awaiting a response
 * - ok: fv sent a request and response came back successfully
 * - error: something went wrong
 */
export type ProcessStatus = (typeof processStatuses)[number]
